import { api } from '../../utils/data-utils';

export type WorkingStatus = 'untested' | 'works' | 'issues' | 'does_not_work';
export type Package = {
  kind: 'cask' | 'formula';
  token: string;
  name: string;
  description: string;
  version: string | null;
  availability: 'available' | 'deprecated' | 'disabled';
  reason: string;
  requirements: unknown;
  command: string | null;
  source: string;
};
export type App = {
  id: string;
  name: string;
  description: string;
  kind: 'cask' | 'formula' | 'missing';
  token: string;
  purpose: string;
  created_by: string;
  created_at: string;
  votes: number;
  needed: boolean;
};
export type Note = {
  id: string;
  text: string;
  result: WorkingStatus;
  app_version: string;
  macos_version: string;
  processor: string;
  email: string;
  created_at: string;
};
export type Detail = {
  app: App;
  notes: Note[];
  reports: Record<Exclude<WorkingStatus, 'untested'>, number>;
  package: Package | null;
  catalogue_error: string | null;
};

export async function request<T>(
  token: string,
  query = '',
  body?: Record<string, unknown>,
): Promise<T> {
  const response = await api(token, `/homebrew${query}`, {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', 'X-Tenant': 'homebrew' },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  return response.json() as Promise<T>;
}

export const failureMessage = (error: unknown) =>
  error instanceof Error
    ? (error as Error & { detail?: string }).detail || error.message
    : 'Unable to complete this request. Please try again.';

export const statusLabels: Record<WorkingStatus, string> = {
  untested: 'Not tested / general note',
  works: 'Works on my MacBook',
  issues: 'Works with issues',
  does_not_work: 'Does not work on my MacBook',
};

export const displayDate = (date: string) =>
  new Date(date).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
